module.exports = __webpack_public_path__ + "img/sld_scb_4_t1_red.101ec61a.svg";